<template>
    <div class="launch-nav">
        <img
            class="logo"
            src="https://s21.lgstatic.com/growth/activity/20210729/1627528017710.png?x-oss-process=style/80"
            alt=""
        >
        <div class="title">
            拉勾教育
        </div>
        <div class="slogan">
            互联网人实战大学
        </div>
        <ul>
            <li
                v-for="(item, index) in campList"
                :key="index"
                :class="{'active': activeTab === index }"
                @click="linkTo(index)"
            >
                <img
                    :src="item.img"
                    alt=""
                >
                <span>{{ item.name }}</span>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'LaunchNav',
    props: {
        activeTab: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            campList: [
                { name: 'Java编程', img: "https://s21.lgstatic.com/growth/activity/20210201/1612147885977.png", url: 'https://kaiwu.lagou.com/java_basic_sem_search.html#/index' },
                { name: '大数据', img: 'https://s21.lgstatic.com/growth/activity/20210201/1612147862200.png', url: 'https://kaiwu.lagou.com/data_basic_sem_search.html#/index' },
                { name: 'Web前端', img: "https://s21.lgstatic.com/growth/activity/20210201/1612147899221.png", url: 'https://kaiwu.lagou.com/web_basic_sem_search.html' },
                { name: '更多课程', img: "https://s21.lgstatic.com/growth/activity/20210308/1615174020302.png", url: 'https://edu.lagou.com/growth/sem/pp_basic_sem_search.html' }
            ]

        };
    },
    methods: {
        linkTo(index) {
            if (this.activeTab !== index) {
                window.open(this.campList[index].url);
            }
        }
    }
};
</script>
<style lang="less" scoped>
.launch-nav {
    width: 150PX;
    // height: 500PX;
    position: fixed;
    top: 50vh;
    transform: translateY(-50%);
    padding: 40PX 0 50PX;
    text-align: center;
    background: #fff;
    border: solid 2px #F5D4B1;
    z-index: 1000;
    box-sizing: border-box;
    user-select: none;

    .logo {
        width: 50PX;
        height: 50PX;
        position: absolute;
        top: -25PX;
        left: 50%;
        transform: translateX(-50%);
    }
}
.title {
    font-size: 16PX;
    font-weight: 600;
    color: #333;
    margin-bottom: 5PX;
}
.slogan {
    font-size: 13PX;
    color: #666;
    margin-bottom: 20PX;
}
.active {
    border: none;
    background: linear-gradient(180deg,rgba(255,241,225,1) 0%,rgba(244,209,172,1) 100%);
}
li {
    width: 100%;
    height: 50PX;
    line-height: 50PX;
    display: flex;
    justify-content: center;
    align-items: center;
    border: solid 2px #F4D1AD;
    border-left: none;
    border-right: none;
    font-size: 14PX;
    color: #333;
    margin-bottom: 15PX;
    transition: background-color .2s;
    cursor: pointer;
    box-sizing: border-box;

    span {
        display: inline-block;
        width: 60PX;
    }

    img {
        width: 20PX;
        height: 20PX;
        margin-right: 10PX;
    }

    &:last-child {
        margin-bottom: 0;
    }

    &:hover {
        border: none;
        background: linear-gradient(180deg,rgba(255,241,225,1) 0%,rgba(244,209,172,1) 100%);
    }
}
</style>
